import type { Rubrique } from './Rubrique';
import type { Tag } from './Tag';

export interface Question {
    faq: {
        id: number;
        title: string;
        content: string;
        sortOrder: number;
        tags: Tag[];
    };
    rubrique: Rubrique;
    tags: Tag[];
}

export const toQuestionForm = (question: Question): QuestionForm => ({
    ...question.faq,
    rubriqueId: question.rubrique.id,
    tags: question.tags.map((t) => t.id),
});

export interface QuestionForm {
    title: string;
    content: string;
    rubriqueId: number;
    sortOrder: number;
    tags: number[];
}

export interface RubriqueWithQuestion extends Rubrique {
    faqs: Question[];
}
